import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "asap_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);
  const add = (item) => setItems((x) => [...x, { ...item, cid: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}` }]);
  const remove = (cid) => setItems((x) => x.filter((i) => i.cid !== cid));
  const clear = () => setItems([]);
  return <CartCtx.Provider value={{ items, add, remove, clear }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
